export const GET_CREDIT_BUNDLES = 'SET_CREDITS';
export const CURRENT_USER_CREDITS = 'SET_CURRENT_CREDITS';
